import Vue from 'vue';
import Router from 'vue-router';
import jwt_decode from 'jwt-decode';

import Home from './views/Home.vue';
import Register from './views/Register.vue';
import Login from './views/Login.vue';

const Dashboard = () =>
    import ('./views/Client/Dashboard');

const ClentVideo = () =>
    import ('./views/Client/Videos');

const Admin = () =>
    import ('./views/Admin/Admin');
const UserEdit = () =>
    import ('./views/Admin/UserEdit');
const NewUser = () =>
    import ('./views/Admin/NewUser');
const Videos = () =>
    import ('./views/Admin/Videos');

const Categories = () =>
    import ('./views/Admin/Category/Categories');

const NewCategory = () =>
    import ('./views/Admin/Category/NewCategory');


const categoryEdit = () =>
    import ('./views/Admin/Category/Edit');

const NewVideo = () =>
    import ('./views/Admin/NewVideo');

const NewClientVideo = () =>
    import ('./views/Client/NewVideo');

const Video = () =>
    import ('./views/Admin/Video');
const EditVideo = () =>
    import ('./views/Admin/EditVideo');
const NotFound = () =>
    import ('./views/404');
const Preview = () =>
    import ('./views/Admin/Preview');
const FooterMenu = () =>
    import ('./views/CMS/FooterMenu');
const NewFooterMenu = () =>
    import ('./views/CMS/NewFooterMenu');
const EditFooterMenu = () =>
    import ('./views/CMS/EditFooterMenu');
const Content = () =>
    import ('./views/CMS/Content');
const EditContent = () =>
    import ('./views/CMS/EditContent');

const EditClientVideo = () =>
    import ('./views/Client/EditVideo');

const ClientCategories = () =>
    import ('./views/Client/category/Index')

const NewClientCategory = () =>
    import ('./views/Client/category/Create')
const EditClientCategory = () =>
    import ('./views/Client/category/Edit')

const ClientPlaylists = () =>
    import ('./views/Client/Playlist/Index')

const NewClientPlayList = () =>
    import ('./views/Client/Playlist/Edit')

const PlaylistWatch = () =>
    import ('./views/Client/Playlist/Watch')

const Page = () =>
    import ('./views/Page');

Vue.use(Router);

function loggedInRedirectToDashboard(to, from, next) {
    if (localStorage.token) {
        next('/dashboard');
    } else {
        next();
    }
}

function isLoggedIn(to, from, next) {
    if (localStorage.token) {
        next();
    } else {
        return location.replace('/');
        // next('/login');
    }
}

function isAdmin(to, from, next) {
    var token = localStorage.token || null;
    if (token != null) {
        var decodedToken = jwt_decode(token);
        if (decodedToken.role == 'admin') {
            next();
        } else {
            return location.replace('/');
        }
    } else {
        return location.replace('/');
    }
}

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/videos',
            name: 'clientVideos',
            component: ClentVideo,
            beforeEnter: isLoggedIn
        },
        {
            path: '/playlist',
            name: 'clientPlaylist',
            component: ClientPlaylists,
            beforeEnter: isLoggedIn
        },
        {
            path: '/playlist/:id',
            name: 'editClientPlayList',
            component: NewClientPlayList,
            beforeEnter: isLoggedIn
        },
        {
            path: '/playlist/watch/:id',
            name: 'playlistWatch',
            component: PlaylistWatch,
            beforeEnter: isLoggedIn
        },
        {
            path: '/register',
            name: 'register',
            component: Register,
            beforeEnter: loggedInRedirectToDashboard
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: loggedInRedirectToDashboard
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: isLoggedIn
        },
        {
            path: '/categories',
            name: 'clientCategories',
            component: ClientCategories,
            beforeEnter: isLoggedIn
        },
        {
            path: '/category/new',
            name: 'newClientCategory',
            component: NewClientCategory,
            beforeEnter: isLoggedIn
        },
        {
            path: '/category/edit/:id',
            name: 'editClientCategory',
            component: EditClientCategory,
            beforeEnter: isLoggedIn,
        },
        {
            path: '/admin',
            name: 'admin',
            component: Admin,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/user/edit/:id',
            name: 'user',
            component: UserEdit,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/category/edit/:id',
            name: 'editCategory',
            component: categoryEdit,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/user/new',
            name: 'newuser',
            component: NewUser,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/videos',
            name: 'videos',
            component: Videos,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/categories',
            name: 'categories',
            component: Categories,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/categories/new',
            name: 'newCategory',
            component: NewCategory,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/video/new',
            name: 'newVideo',
            component: NewVideo,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/videos/new',
            name: "newClientVideo",
            component: NewClientVideo,
            beforeEnter: isLoggedIn,
        },
        {
            path: '/admin/video/:id',
            name: 'video',
            component: Video,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/video/edit/:id',
            name: 'editVideo',
            component: EditVideo,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/videos/edit/:id',
            name: 'editClientVideo',
            component: EditClientVideo,
            beforeEnter: isLoggedIn,
        },
        {
            path: '/admin/footer-menu',
            name: 'footer',
            component: FooterMenu,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/footer-menu/new',
            name: 'newFooterMenu',
            component: NewFooterMenu,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/footer-menu/edit/:id',
            name: 'editFooterMenu',
            component: EditFooterMenu,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/content',
            name: 'content',
            component: Content,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/admin/content/edit/:id',
            name: 'EditContent',
            component: EditContent,
            beforeEnter: isAdmin,
            meta: {
                layout: 'admin'
            }
        },
        {
            path: '/preview/reiframe/:id',
            name: 'preview',
            component: Preview,
            // beforeEnter: isAdmin,
            meta: {
                layout: 'video'
            }
        },
        {
            path: '/notfound',
            name: '404',
            component: NotFound
        },

        {
            path: '/:slug',
            name: 'page',
            component: Page
        },

        { path: '*', redirect: '/home' }
    ]
});